import React, { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Card,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Label,
  Row,
  UncontrolledAccordion,
} from "reactstrap"
import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { UFEditor, UFInput } from "../../../components/Common/Fields/Input"
import LoadingButton from "../../../components/Common/LoadingButton"
import {
  fetchEmployee,
  postHrmsEmployeeControl,
} from "../../../services/Hrms/hrms"
import {
  fetchGeneralSetting,
  postGeneralSettings,
} from "../../../services/Settings/settings"
import PhoneInputField from "../../../components/Common/Fields/phoneInput"
import SingleFileInput from "../../../components/Common/Fields/singleFileInput"
import StateList from "../../../components/Common/chooseFields/stateList"
import Country from "../../../components/Common/chooseFields/country"
import { set } from "lodash"
import DesimalPoint from "../../../components/Common/chooseFields/desimalPoint"

const schema = yup.object().shape({
  companyaddress: yup.string().required("Company Address is required"),
  website: yup.string().required("Company Website is required"),
  // phone: yup.number().required("Contact Number is required"),
  phone: yup
    .string()
    .required("Contact Number is required")
    .test("is-valid-phone", "Please enter a valid contact number", value => {
      // Check if the value is more than just '+' or empty
      return value && value.replace(/\D/g, "").length > 1
    }),
  companyname: yup.string().required("Company Name is required"),
  companyemail: yup
    .string()
    .required("Company Email is required")
    .email("Please enter a valid email"),
  companyinfo: yup.string().required("Site Moto is required"),
  companyzipcode: yup.string().required("PO Box Number is required"),
  companycountry: yup
    .object()
    .shape({
      value: yup.string().required("State is required"),
      label: yup.string().required("State is required"),
    })
    .required("State is required"),
  copyright: yup.string().required("Copyright is required"),
  vat_no: yup.string().required("VAT No is required"),
  desimal_point: yup
    .object()
    .shape({
      value: yup.number().required("Decimal Point is required"),
      label: yup.string().required("Decimal Point is required"),
    })
    .required("Decimal Point is required"),
  companylogo: yup.mixed().required("Logo is required"),
  companyfavicon: yup.mixed().required("Meta Image is required"),
  country_id: yup
    .object()
    .shape({
      value: yup.string().required("Country is required"),
      label: yup.string().required("Country is required"),
    })
    .required("Country is required"),
})

const EditGeneral = () => {
  const companyname = localStorage.getItem("companyname")
  document.title = `General Setting${
    companyname ? ` | ${companyname}` : "MEP -Hub"
  }`
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const [refresh, setRefresh] = useState(0)
  const [file, setFile] = useState()
  const [faviconFile, setFaviconFile] = useState()
  const [smallLogo, setSmallLogo] = useState()
  const [documentName1, setDocumentName1] = useState()
  const [documentName2, setDocumentName2] = useState()
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      percentage: 0,
      preliminary_per: 0,
      overheads_per: 0,
      tax: 0,
      po_remarks: "",
      po_pay_term: "",
      grn_text: "",
      companyaddress: "",
      website: "",
      phone: "",
      companylogo: "",
    },
  })
  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
  })

  console.log("justforcheck", watch("desimal_point"))

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const imgUrl = process.env.REACT_APP_IMG_APIKEY

  const handleRegistration = async data => {
    console.log(`dataaa`, data)

    try {
      setIsLoading(true)

      const payload = {
        ...data,
        companycountry: data?.companycountry?.value,
        desimal_point: data?.desimal_point?.value
          ? data?.desimal_point?.value
          : 2,
      }

      // Include companylogo only if it's a file
      if (
        data?.companylogo instanceof File ||
        (Array.isArray(data?.companylogo) &&
          data?.companylogo?.[0] instanceof File)
      ) {
        payload.companylogo = data.companylogo[0]
      } else {
        delete payload.companylogo // Ensure it's not included
      }

      if (
        data?.companyfavicon instanceof File ||
        (Array.isArray(data?.companyfavicon) &&
          data?.companyfavicon?.[0] instanceof File)
      ) {
        payload.companyfavicon = data.companyfavicon[0]
      } else {
        delete payload.companyfavicon // Ensure it's not included
      }

      if (
        data?.mob_svg instanceof File ||
        (Array.isArray(data?.mob_svg) && data?.mob_svg?.[0] instanceof File)
      ) {
        payload.mob_svg = data.mob_svg[0]
      } else {
        delete payload.mob_svg // Ensure it's not included
      }

      const updateDepartment = await postGeneralSettings(payload)
      // const updateDepartment = await postGeneralSettings({
      //   ...data,
      //   companylogo: data?.companylogo?.[0],
      //   companycountry: data?.companycountry?.value,
      //   companyfavicon: data?.companyfavicon?.[0],
      // })
      setRefresh(refresh + 1)
      toastSuccess(updateDepartment?.message)
      navigate("/settings")
    } catch (err) {
      toastError(err?.message)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    const handleFetchGeneralSetting = async () => {
      const response = await fetchGeneralSetting("1")
      // localStorage.setItem("desimalrange", Number(response?.data?.desimal_point))
      console.log("response :", response?.data)
      reset({
        ...response?.data,
        companycountry: {
          label: response?.data?.state?.name,
          value: response?.data?.state?.id,
        },
        country_id: {
          label: response?.data?.state?.country?.name,
          value: response?.data?.state?.country?.id,
        },
        desimal_point: {
          label: response?.data?.desimal_point,
          value: Number(response?.data?.desimal_point),
        },
      })
      // setDocumentName1(response?.data?.companylogo ? response?.data?.companylogo : null),
      // setDocumentName2(response?.data?.companyfavicon ? response?.data?.companyfavicon : null)
      setFile(`${imgUrl}${response?.data?.companylogo || ""}`)
      setFaviconFile(`${imgUrl}${response?.data?.companyfavicon || ""}`)
      setSmallLogo(`${imgUrl}${response?.data?.mob_svg || ""}`)
    }

    handleFetchGeneralSetting()
  }, [refresh])

  const handleChange = (name, file) => {
    console.log(`filee`, file)
    setValue(name, file)
    setFile(URL.createObjectURL(file[0]))
  }

  const handleFaviconChange = (name, file) => {
    console.log(`filee`, file)
    setValue(name, file)
    setFaviconFile(URL.createObjectURL(file[0]))
  }

  const handleSmallLogoChange = (name, file) => {
    console.log(`filee`, file)
    setValue(name, file)
    setSmallLogo(URL.createObjectURL(file[0]))
  }
  console.log(`filee1`, file)

  const handleState = () => {
    setValue(`companycountry`, null)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <FormProvider {...methods}>
            <Form
              id={`general-setting-form`}
              onSubmit={handleSubmit(handleRegistration)}
            >
              <div className="sticky-top w-100">
                <div className="d-flex justify-content-between me-2">
                  <Breadcrumbs
                    title="Setting"
                    breadcrumbObject={[
                      { title: "Setting", link: "/settings" },
                      { title: crumb || "Masters", link: "/settings" },
                      { title: "General Setting", link: "/settings-general" },
                    ]}
                  />
                  <LoadingButton
                    form={`general-setting-form`}
                    color={"primary"}
                    loading={isLoading}
                    disabled={isLoading}
                    className={"px-2 mb-3 me-1 btn btn-primary"}
                    type="submit"
                  >
                    Update
                  </LoadingButton>
                </div>
              </div>
              <Container fluid className="ps-lg-0">
                <Card className="invoice-main-card p-3 pt-4">
                  <Row className="">
                    <Row className="mb-4 mt-2">
                      {/* <Col sm={3}>
                        <FormGroup className="mb-4">
                          <Label>
                            GRN Terms and Conditions
                            <span className="mandatory">*</span>
                          </Label>
                          <UFEditor
                            control={control}
                            placeholder="Enter Terms and Conditions"
                            rows="5"
                            name={"grn_text"}
                            invalid={!!errors.grn_text}
                          />
                          <FormFeedback invalid>
                            {errors.grn_text?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col sm={3}>
                        <FormGroup className="mb-4">
                          <Label>
                            PO Terms and Conditions
                            <span className="mandatory">*</span>
                          </Label>
                          <UFEditor
                            control={control}
                            placeholder="Enter Terms and Conditions"
                            rows="5"
                            name={"po_pay_term"}
                            invalid={!!errors.po_pay_term}
                          />
                          <FormFeedback invalid>
                            {errors.po_pay_term?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col sm={3}>
                        <FormGroup className="mb-4">
                          <Label>
                            PO Remarks
                            <span className="mandatory">*</span>
                          </Label>
                          <UFEditor
                            control={control}
                            placeholder="Enter Remarks"
                            rows="5"
                            name={"po_remarks"}
                            invalid={!!errors.po_remarks}
                          />
                          <FormFeedback invalid>
                            {errors.po_remarks?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col sm={3}>
                        <FormGroup className="mb-4">
                          <Label>
                            Company Address
                            <span className="mandatory">*</span>
                          </Label>
                          <UFEditor
                            control={control}
                            placeholder="Enter address"
                            rows="5"
                            name={"companyaddress"}
                            invalid={!!errors.companyaddress}
                          />
                          <FormFeedback invalid>
                            {errors.companyaddress?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col> */}
                    </Row>
                    <Row>
                      <Col sm={3}>
                        <FormGroup className="mb-4">
                          <Label>
                            Company Name
                            <span className="mandatory">*</span>
                          </Label>
                          <UFInput
                            control={control}
                            placeholder="Enter Company Name"
                            name={"companyname"}
                            invalid={!!errors.companyname}
                          />
                          <FormFeedback invalid>
                            {errors.companyname?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col sm={3}>
                        <FormGroup className="mb-4">
                          <Label>
                            Company Website
                            <span className="mandatory">*</span>
                          </Label>
                          <UFInput
                            control={control}
                            placeholder="Enter website"
                            name={"website"}
                            invalid={!!errors.website}
                          />
                          <FormFeedback invalid>
                            {errors.website?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col sm={3}>
                        <FormGroup className="mb-4">
                          <Label>
                            Company Email
                            <span className="mandatory">*</span>
                          </Label>
                          <UFInput
                            control={control}
                            placeholder="Enter Email"
                            name={"companyemail"}
                            invalid={!!errors.companyemail}
                          />
                          <FormFeedback invalid>
                            {errors.companyemail?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col sm={3}>
                        <FormGroup className="mb-4">
                          <Label>
                            Contact Number
                            <span className="mandatory">*</span>
                          </Label>
                          <PhoneInputField
                            control={control}
                            name={"phone"}
                            invalid={!!errors.phone}
                            // Add these props to ensure proper validation
                            defaultCountry="AE" // Set your default country code
                            countryCodeEditable={true}
                          />
                          <FormFeedback invalid>
                            {errors.phone?.message}
                          </FormFeedback>
                        </FormGroup>
                        {/* <FormGroup className="mb-4">
                          <Label>
                            Contact Number
                            <span className="mandatory">*</span>
                          </Label>
                          <PhoneInputField
                            control={control}
                            name={"phone"}
                            invalid={!!errors.phone}
                          />
                          <FormFeedback invalid>
                            {errors.phone?.message}
                          </FormFeedback>
                        </FormGroup> */}
                      </Col>
                      <Col sm={3}>
                        <FormGroup className="mb-4">
                          <Label>
                            Site Moto
                            <span className="mandatory">*</span>
                          </Label>
                          <UFInput
                            control={control}
                            placeholder="Enter PO Box Number"
                            name={"companyinfo"}
                            invalid={!!errors.companyinfo}
                          />
                          <FormFeedback invalid>
                            {errors.companyinfo?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col sm={3}>
                        <FormGroup className="mb-4">
                          <Label>
                            PO Box Number
                            <span className="mandatory">*</span>
                          </Label>
                          <UFInput
                            control={control}
                            placeholder="Enter PO Box Number"
                            name={"companyzipcode"}
                            invalid={!!errors.companyzipcode}
                          />
                          <FormFeedback invalid>
                            {errors.companyzipcode?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col sm={3}>
                        <FormGroup className="mb-4">
                          <Label>Country</Label>
                          <Country
                            control={control}
                            placeholder="select"
                            name={"country_id"}
                            invalid={!!errors.country_id}
                            target={"body"}
                            onSelectChange={() => handleState()}
                          />
                          <FormFeedback invalid>
                            {errors.country_id?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col sm={3}>
                        <FormGroup className="mb-4">
                          <Label>
                            State<span className="mandatory">*</span>
                          </Label>
                          <StateList
                            control={control}
                            placeholder="select"
                            name={"companycountry"}
                            selectedCountry={watch("country_id")}
                          />
                          <FormFeedback invalid>
                            {errors.companycountry?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col sm={3}>
                        <FormGroup className="mb-4">
                          <Label>
                            Company Address
                            <span className="mandatory">*</span>
                          </Label>
                          <UFEditor
                            control={control}
                            placeholder="Enter address"
                            rows="5"
                            name={"companyaddress"}
                            invalid={!!errors.companyaddress}
                          />
                          <FormFeedback invalid>
                            {errors.companyaddress?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col sm={3}>
                        <FormGroup className="mb-4">
                          <Label>
                            Copyright
                            <span className="mandatory">*</span>
                          </Label>
                          <UFInput
                            control={control}
                            placeholder="Enter Copyright"
                            name={"copyright"}
                            invalid={!!errors.copyright}
                          />
                          <FormFeedback invalid>
                            {errors.copyright?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col sm={3}>
                        <FormGroup className="mb-4">
                          <Label>
                            VAT No
                            <span className="mandatory">*</span>
                          </Label>
                          <UFInput
                            control={control}
                            placeholder="Enter VAT No"
                            name={"vat_no"}
                            invalid={!!errors.vat_no}
                          />
                          <FormFeedback invalid>
                            {errors.vat_no?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col sm={3}>
                        <FormGroup className="mb-4">
                          <Label>
                            Decimal Point
                            <span className="mandatory">*</span>
                          </Label>
                          <DesimalPoint
                            control={control}
                            placeholder="Select Decimal  Point"
                            name={"desimal_point"}
                            invalid={!!errors.desimal_point}
                          />
                          <FormFeedback invalid>
                            {errors.desimal_point?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="mb-4 mt-2">
                      <Col sm={3}>
                        <FormGroup className="mb-4">
                          <Label>
                            Logo
                            <span className="mandatory">*</span>
                          </Label>
                          <SingleFileInput
                            control={control}
                            accept=".svg"
                            name={`companylogo`}
                            label="Upload File"
                            onlyIcon={true}
                            tooltip="Document Upload"
                            handleChange={handleChange}
                            downloadPath={file}
                            // multiple={true}
                          />
                          <FormFeedback invalid>
                            {errors.companylogo?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col sm={3}>
                        <div className="p-2 settings-logo">
                          <img src={file} />
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-4 mt-2">
                      <Col sm={3}>
                        <FormGroup className="mb-4">
                          <Label>
                            Small Logo
                            <span className="mandatory">*</span>
                          </Label>
                          <SingleFileInput
                            control={control}
                            accept=".svg"
                            name={`mob_svg`}
                            label="Upload File"
                            onlyIcon={true}
                            tooltip="Logo Upload"
                            handleChange={handleSmallLogoChange}
                            downloadPath={smallLogo}
                            // multiple={true}
                          />
                          <FormFeedback invalid>
                            {errors.mob_svg?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col sm={3}>
                        <div className="p-2 settings-logo">
                          <img src={smallLogo} />
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-4 mt-2">
                      <Col sm={3}>
                        <FormGroup className="mb-4">
                          <Label>
                            Meta Image
                            <span className="mandatory">*</span>
                          </Label>
                          <SingleFileInput
                            control={control}
                            accept=".svg,.jpg,.png"
                            name={`companyfavicon`}
                            label="Upload File"
                            onlyIcon={true}
                            tooltip="Document Upload"
                            handleChange={handleFaviconChange}
                            downloadPath={faviconFile}
                            // multiple={true}
                          />
                          <FormFeedback invalid>
                            {errors.companyfavicon?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col sm={3}>
                        <div className="p-2 settings-logo">
                          <img src={faviconFile} />
                        </div>
                      </Col>
                    </Row>

                    {/* <Row>
                      <Col sm={6}>
                        <FormGroup className="mb-4">
                          <Label>
                            Logo
                            <span className="mandatory">*</span>
                          </Label>
                          <SingleFileInput
                            control={control}
                            accept=".png,.jpg,.jpeg,.svg"
                            name={`companylogo`}
                            label="Upload File"
                            onlyIcon={true}
                            tooltip="Cerificate Upload"
                            handleChange={handleChange}
                            downloadPath={profile}
                          />
                          <FormFeedback invalid>
                            {errors.companylogo?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                    </Row> */}
                    {/* <Col sm={12} className="general-setting">
                      <UncontrolledAccordion defaultOpen={["1"]}>
                        <AccordionItem>
                          <AccordionHeader targetId="1">
                            <h6>Project Setting</h6>
                          </AccordionHeader>
                          <AccordionBody accordionId="1">
                            <Row className="mb-4 mt-2">
                              <Col sm={3}>
                                <FormGroup className="mb-4">
                                  <Label>
                                    Project Value Variation (%)
                                    <span className="mandatory">*</span>
                                  </Label>
                                  <UFInput
                                    control={control}
                                    placeholder="Enter the Variation"
                                    name={"percentage"}
                                    invalid={!!errors.percentage}
                                  />
                                  <FormFeedback invalid>
                                    {errors.percentage?.message}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                            </Row>
                          </AccordionBody>
                        </AccordionItem>
                        <hr className="m-0" />
                        <AccordionItem>
                          <AccordionHeader targetId="2">
                            <h6>GRN Setting</h6>
                          </AccordionHeader>
                          <AccordionBody accordionId="2">
                            <Row className="mb-4 mt-2">
                              <Col sm={4}>
                                <FormGroup className="mb-4">
                                  <Label>
                                    Terms and Conditions
                                    <span className="mandatory">*</span>
                                  </Label>
                                  <UFEditor
                                    control={control}
                                    placeholder="Enter Terms and Conditions"
                                    rows="5"
                                    name={"grn_text"}
                                    invalid={!!errors.grn_text}
                                  />
                                  <FormFeedback invalid>
                                    {errors.grn_text?.message}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                            </Row>
                          </AccordionBody>
                        </AccordionItem>
                        <hr className="m-0" />
                        <AccordionItem>
                          <AccordionHeader targetId="3">
                            <h6>Purchase Order Setting</h6>
                          </AccordionHeader>
                          <AccordionBody accordionId="3">
                            <Row className="mb-4 mt-2">
                              <Col sm={3}>
                                <FormGroup className="mb-4">
                                  <Label>
                                    Terms and Conditions
                                    <span className="mandatory">*</span>
                                  </Label>
                                  <UFEditor
                                    control={control}
                                    placeholder="Enter Terms and Conditions"
                                    rows="5"
                                    name={"po_pay_term"}
                                    invalid={!!errors.po_pay_term}
                                  />
                                  <FormFeedback invalid>
                                    {errors.po_pay_term?.message}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                              <Col sm={3}>
                                <FormGroup className="mb-4">
                                  <Label>
                                    Remarks
                                    <span className="mandatory">*</span>
                                  </Label>
                                  <UFEditor
                                    control={control}
                                    placeholder="Enter Remarks"
                                    rows="5"
                                    name={"po_remarks"}
                                    invalid={!!errors.po_remarks}
                                  />
                                  <FormFeedback invalid>
                                    {errors.po_remarks?.message}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                            </Row>
                          </AccordionBody>
                        </AccordionItem>
                        <hr className="m-0" />
                      </UncontrolledAccordion>
                    </Col> */}
                  </Row>
                </Card>
              </Container>
            </Form>
          </FormProvider>
        </div>
      </div>
    </React.Fragment>
  )
}

export default EditGeneral
